/* Cayo Store homepage reel: seamless RIGHT-TO-LEFT loop (reverse of the password-page splash).
   Two identical copies of the strip, split into segments (<= 3.2x the reel height wide, iOS-friendly
   GPU layers), whole-pixel image widths so the loop point is pixel-identical, compositor-driven
   Web Animations. prefers-reduced-motion: static frame. Re-inits on shopify:section:load. */
(function () {
  'use strict';
  var MAX_SEG_ASPECT = 3.2, WAIT_MAX = 8000;
  var reduceMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function init(root) {
    if (!root || root.__cayoReel) return;
    var reel = root.querySelector('.cayo-home__reel');
    var photos = [];
    try { photos = JSON.parse(root.querySelector('.cayo-home__data').textContent); } catch (e) { photos = []; }
    if (!reel || !photos.length) return;
    var speed = parseFloat(root.getAttribute('data-reel-speed')) || 40;
    var anims = [], cycleMs = 0, distance = 0, allImgs = [];

    function makeCopy() {
      var out = [], seg = null, aspect = 0;
      photos.forEach(function (p) {
        var a = p.w / p.h;
        if (!seg || aspect + a > MAX_SEG_ASPECT) {
          seg = document.createElement('div'); seg.className = 'cayo-home__seg'; out.push(seg); aspect = 0;
        }
        aspect += a;
        var img = document.createElement('img');
        img.width = p.w; img.height = p.h; img.alt = ''; img.decoding = 'async'; img.draggable = false;
        img.addEventListener('error', function onErr() { img.removeEventListener('error', onErr); if (p.jpg) img.src = p.jpg; });
        img.src = p.webp;
        seg.appendChild(img); allImgs.push(img);
      });
      return out;
    }
    var copyA = makeCopy(), copyB = makeCopy(), segs = copyA.concat(copyB);
    segs.forEach(function (s) { reel.appendChild(s); });

    function sizeImages() {
      var h = reel.getBoundingClientRect().height;
      allImgs.forEach(function (img) { img.style.width = Math.round(h * img.width / img.height) + 'px'; });
    }
    function measure() { sizeImages(); return copyB[0].getBoundingClientRect().left - copyA[0].getBoundingClientRect().left; }
    function stop() {
      var progress = 0;
      if (anims.length && cycleMs) progress = ((anims[0].currentTime || 0) % cycleMs) / cycleMs;
      anims.forEach(function (a) { a.cancel(); }); anims = [];
      return progress;
    }
    function start(progress) {
      distance = measure();
      if (!(distance > 0) || reduceMQ.matches || !reel.animate) return;   // static frame
      cycleMs = distance / speed * 1000;
      // right-to-left: strip moves from 0 to -distance (copy B ends exactly where copy A started)
      var kf = [{ transform: 'translate3d(0,0,0)' }, { transform: 'translate3d(' + (-distance) + 'px,0,0)' }];
      segs.forEach(function (s) { anims.push(s.animate(kf, { duration: cycleMs, iterations: Infinity, easing: 'linear' })); });
      var t = (progress || 0) * cycleMs;
      anims.forEach(function (a) { a.currentTime = t; });
    }
    var jobs = allImgs.map(function (img) {
      return new Promise(function (resolve) {
        function dec() { (img.decode ? img.decode() : Promise.resolve()).then(resolve, function () { setTimeout(resolve, 50); }); }
        if (img.complete && img.naturalWidth) dec(); else img.addEventListener('load', dec, { once: true });
        img.addEventListener('error', function () { setTimeout(function () { if (img.complete && img.naturalWidth) dec(); }, 0); });
      });
    });
    Promise.race([Promise.all(jobs), new Promise(function (r) { setTimeout(r, WAIT_MAX); })]).then(function () {
      start(0);
      requestAnimationFrame(function () { reel.classList.add('is-ready'); });
    });
    var lastH = reel.getBoundingClientRect().height, timer = null;
    function onResize() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var h = reel.getBoundingClientRect().height;
        if (Math.abs(h - lastH) < 1 || !reel.classList.contains('is-ready')) return;
        lastH = h; start(stop());
      }, 200);
    }
    window.addEventListener('resize', onResize);
    if (reduceMQ.addEventListener) reduceMQ.addEventListener('change', function () { if (reel.classList.contains('is-ready')) start(stop()); });
    root.__cayoReel = { distance: function () { return distance; }, cycleMs: function () { return cycleMs; }, anims: function () { return anims; } };
    window.__cayoHomeReel = root.__cayoReel;
  }
  function initAll() { Array.prototype.forEach.call(document.querySelectorAll('.cayo-home'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) { if (e.target) Array.prototype.forEach.call(e.target.querySelectorAll('.cayo-home'), init); });
})();
